exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chips .chip{background:url(\"https://d2rzfffph148bz.cloudfront.net/web_store/images/desktop/web_pc_dinero_bg.png\") bottom no-repeat}.chips .chip .permissions .loyalty{margin-left:12px}.chips .chip .permissions .loyalty>div{position:absolute;top:5%}.chips .chip .permissions .loyalty .icon-loyalty,.chips .chip .permissions .loyalty .loyalty-points{flex:0 0 auto}.mobile .chips .chip{background:url(\"https://d2rzfffph148bz.cloudfront.net/web_store/images/common/dineros_icon/web_phone_dinero_bg.png\") bottom no-repeat}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5a72ad80","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layouts/chips.vue
// module id = 430
// module chunks = 0